<template>
    <div class="page hotel mx-4">       

        <!-- Galeria -->
        <div class="header hotel-carousel position-relative mb-2">            
            <!-- Flickity HTML init -->
            <flickity ref="flickity" :options="flickityOptions" class="gallery">
                <div class="gallery-cell" v-for="(imagen,index) in imagenes" :key="index">
                    <img class="gallery-cell-image flickity-lazyloaded flickity-lazyerror" :src="imagen">                        
                </div>                
            </flickity>
        </div>
    
    </div>    
</template>

<script>

import Flickity from 'vue-flickity';
// import hotelPrecios from '@/components/HotelPrecios.vue'

export default {
    name: 'hotel-imagenes',

    components: {
        Flickity, 
        
    },
    data() {
        return {
            //titulo: "INFORMACIÓN HOTEL",

            listaImagen: [],
            
            flickityOptions: {
                autoPlay: true,
                initialIndex: 0,
                prevNextButtons: true,
                pageDots: true,
                freeScroll: true,
                wrapAround: true,
                draggable: false,
                adaptiveHeight: true,
                
            },
            
            slide: 0,
            sliding: null
        }
    },
    computed: {
        hotel() {
            return this.$store.state.hotel;
        },

        imagenes() {
            let url="https://iberopa.com/_abk/lib/imagendb.php?w=123|vc_telefonica|hoteles_img|";
            let A=[];        
            this.hotel.imagenes.split(',').forEach(value => {
                A.push(url+value);                
            });            
            //console.log(A);
            return A;
        },
    },
    methods: {
        async hotel_precios() { 
            await this.$store.dispatch('hotel_precios',this.hotel);
            this.$bvModal.show("modal_hotelPrecios");            
        },
        //galeria
        next() {
            this.$refs.flickity.next();
        },    
        prev() {
            this.$refs.flickity.previous();
        },

        onSlideStart() {
            this.sliding = true
        },
        onSlideEnd() {
            this.sliding = false
        },
    },
    created() {        
        if (this.hotel.id==undefined) {
            this.$router.push('/catalogo');
        }
        //console.log('*hotel_info.created',this.hotel.hot);
    },
    mounted() {        
    },
}
</script>